import type { FaireProductEntity } from "../../entity_types/product";

export const p_wzteqpuheg: FaireProductEntity = {
  token: "p_wzteqpuheg",
  type: "product",
  name: "Armband leren veter met licht purple hart",
  brandName: "Upscaling Demo Brand",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/e64557640a399294aaff3c494b35d3714b723551b68b1076b9366748600c9e49.jpeg",
  afterImageUrl:
    "https://cdn.prerelease.faire.dev/fastly/0856d19293d9f5543b75221cdf4fed99d6887f03908adf18f37b37ce33573328.jpeg",
  priceDollars: 24,
  description: "Image upscaling comparison product.",
  categoryTokens: ["cat_proto_image-upscaling"],
  tags: ["upscaling"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
